var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-action-buttons"},[(this.$can('update-types'))?_c('i',{staticClass:"fa fa-edit fa-lg pointer",attrs:{"title":_vm.uLang('app.configure_setting', { setting: _vm.lang('app.' + this.data.name) })},on:{"click":_vm.edit}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }